// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38Ayn","icon":"styles_icon__2glUX"};